import { render, staticRenderFns } from "./SubmissionsBoard.vue?vue&type=template&id=1d207c60&scoped=true&"
import script from "./SubmissionsBoard.vue?vue&type=script&lang=ts&"
export * from "./SubmissionsBoard.vue?vue&type=script&lang=ts&"
import style0 from "./SubmissionsBoard.vue?vue&type=style&index=0&id=1d207c60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d207c60",
  null
  
)

export default component.exports